import { makeStyles, shorthands } from "@fluentui/react-components";

const usePersonalAccessTokenStyles = makeStyles({
  root: {
    marginBottom: "12px",
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("12px"),
  },

  buttonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "12px",
    ...shorthands.gap("8px"),
  },
});

export default usePersonalAccessTokenStyles;
